import { useAtom } from 'jotai'
import { apiEnvironmentAtom } from '@/core/store/environment.store'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'

export const EnvironmentSwitcher = () => {
    const [env, setEnv] = useAtom(apiEnvironmentAtom)
    // eslint-disable-next-line turbo/no-undeclared-env-vars -- Vite built-in, not a user env var
    const isDev = import.meta.env.DEV
    const isFgDev = typeof window !== 'undefined' && window.location.hostname === 'u-feelgreat-dev.unicity.com'

    if (!isDev && !isFgDev) return null

    return (
        <Stack
            direction="row"
            alignItems="center"
            gap={1}
            sx={{
                position: 'fixed',
                bottom: 8,
                right: 8,
                zIndex: 9999,
                bgcolor: 'rgba(0,0,0,0.7)',
                borderRadius: 2,
                px: 1.5,
                py: 0.5
            }}
            data-testid="environment-switcher-stack-typography-api">
            <Typography variant="caption" color="white" fontSize={10} data-testid="environment-switcher-typography-api">
                API:
            </Typography>
            <Chip
                label={env.toUpperCase()}
                size="small"
                color={env === 'live' ? 'success' : 'warning'}
                onClick={() => setEnv(env === 'live' ? 'dev' : 'live')}
                sx={{ cursor: 'pointer', height: 20, fontSize: 10 }}
                data-testid="environment-switcher-chip"
            />
        </Stack>
    )
}
